import { motion } from "framer-motion";
import { Chapter, Reveal } from "@/components/landing/Reveal";

const QuoteLine = ({ text, gold, delay }) => (
  <span className={`block ${gold ? "text-[#D4AF37]" : "text-[#F5F5F5]"}`}>
    {text.split(" ").map((word, i) => (
      <motion.span
        key={i}
        initial={{ opacity: 0.12 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true, margin: "-30%" }}
        transition={{ duration: 0.5, delay: delay + i * 0.08 }}
        className="inline-block"
      >
        {word}
        {"\u00A0"}
      </motion.span>
    ))}
  </span>
);

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      className="relative overflow-hidden bg-[#0C0C0C] py-28 sm:py-40"
      data-testid="philosophy-section"
    >
      <span
        className="text-outline pointer-events-none absolute -right-10 top-1/2 hidden -translate-y-1/2 select-none font-display text-[22rem] font-extrabold leading-none lg:block"
        aria-hidden="true"
      >
        pitsora
      </span>
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(circle at 20% 50%, rgba(212,175,55,0.05) 0%, transparent 55%)" }}
        aria-hidden="true"
      />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <Chapter index="06" label="The Philosophy" testid="philosophy-chapter" />

        <Reveal>
          <h2 className="max-w-4xl font-display text-3xl font-bold leading-[1.12] tracking-tight sm:text-4xl lg:text-5xl">
            AI should accelerate the story.
            <span className="mt-2 block text-[#9A9A9A]">
              Not replace the <span className="text-[#D4AF37]">storyteller.</span>
            </span>
          </h2>
        </Reveal>

        <Reveal delay={0.15} className="mt-10 max-w-2xl space-y-5 text-base leading-relaxed text-[#9A9A9A] sm:text-lg">
          <p>
            pitsora is being built around a simple idea:{" "}
            <span className="text-[#F5F5F5]">
              creators should control the story — AI should handle the production complexity.
            </span>
          </p>
          <p>AI can research, organize, draft, generate, and assemble. The creator decides what matters.</p>
        </Reveal>

        <div className="mt-20 max-w-4xl" data-testid="philosophy-quote-container">
          <span className="font-display text-8xl leading-none text-[#D4AF37]" aria-hidden="true">
            &ldquo;
          </span>
          <blockquote
            className="-mt-6 font-display text-3xl font-bold leading-[1.25] tracking-tight sm:text-4xl lg:text-[3.4rem]"
            data-testid="philosophy-quote-text"
          >
            <QuoteLine text="You bring the question." delay={0} />
            <QuoteLine text="PITSORA helps build the story." gold delay={0.4} />
          </blockquote>
          <Reveal delay={0.3} className="mt-8 flex items-center gap-4">
            <span className="h-px w-12 bg-[#D4AF37]/60" aria-hidden="true" />
            <span className="font-mono text-[10px] uppercase tracking-[0.35em] text-[#666666]">
              The pitsora Manifesto
            </span>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
